import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button} from 'views/components';

import {ChevronRight} from 'views/icons';

import {Translate} from 'views/module';


const ClientDescription = (props) => {
  const setOpenDrawerView = props.setOpenDrawerView;
  const showSettings = props.showSettings;

  if (showSettings) {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          py: 1,
          px: {md: 2, xs: 1},
          borderBlock: '1px solid #E0E0E0',
        }}
      >
        <Typography sx={{textTransform: 'uppercase', fontWeight: 500}}>
          <Translate expression='client.ClientDetail.Settings.SettingsDescription'/>
        </Typography>
        <Button
          startIcon={<ChevronRight />}
          variant='outlined'
          onClick={() => setOpenDrawerView(true)}
          data-testid='settingsDrawerView'
        >
          <Typography sx={{fontSize: '16px', textTransform: 'uppercase', fontWeight: 500}}>
            <Translate expression='generic.View'/>
          </Typography>
        </Button>
      </Stack>
    );
  } else {
    return null;
  }
};
ClientDescription.propTypes = {
  clientRn: PropTypes.string.isRequired,
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
  showSettings: PropTypes.bool.isRequired,
  setOpenDrawerView: PropTypes.func.isRequired,
};

export default React.memo(ClientDescription);
